import {Component, inject, OnInit} from '@angular/core';
import {
  ContainerComponent,
  ColComponent,
  RowComponent,
  ListGroupDirective,
  ListGroupItemDirective
} from "@coreui/angular";
import {ChooseYourGameComponent} from "../../components/choose-your-game/choose-your-game.component";
import {HasPermissionDirective} from "../../directives/permissions/has-permission";
import {UserHasCausableAdminAccessDirective} from "../../directives/permissions/user-has-causable-admin-access.directive";
import {PermissionTypes} from "../../enum/PermissionTypes";
import {GameAdminManageNotificationsComponent} from "./game-admin-manage-notifications/game-admin-manage-notifications.component";
import {CausableAdminManageNotificationsComponent} from "./causable-admin-manage-notifications/causable-admin-manage-notifications.component";
import {CrossGameManageNotificationsComponent} from "./cross-game-manage-notifications/cross-game-manage-notifications.component";
import {NgIf} from "@angular/common";
import {PermissionsService} from "../../services/permissions.service";
import {HasCrossGamePermissionDirective} from "../../directives/permissions/has-cross-game-permission";

@Component({
  selector: 'app-manage-notifications',
  standalone: true,
  imports: [
    ContainerComponent,
    ColComponent,
    RowComponent,
    ListGroupDirective,
    ListGroupItemDirective,
    ChooseYourGameComponent,
    HasPermissionDirective,
    UserHasCausableAdminAccessDirective,
    GameAdminManageNotificationsComponent,
    CausableAdminManageNotificationsComponent,
    CrossGameManageNotificationsComponent,
    NgIf,
    HasCrossGamePermissionDirective
  ],
  templateUrl: './manage-notifications.component.html',
})
export class ManageNotificationsComponent implements OnInit {
  public permissionTypes = PermissionTypes;
  public isCausableAdmin: boolean = false;
  public hasCrossGamePermission: boolean = false;

  private permissionsService = inject(PermissionsService);

  ngOnInit() {
    this.permissionsService.hasCausableAdminPermissions().subscribe(hasAccess => {
      this.isCausableAdmin = hasAccess;
    });

    this.hasCrossGamePermission = this.permissionsService.userHasCrossGamePermission(PermissionTypes.ViewBroadcastNotifications);
  }
}
